/**
 * Utility functions for formatting data in CustomerProfile
 */

/**
 * Format date string to YYYY-MM-DD for date inputs
 */
export const formatDateForInput = (dateString: string | null | undefined): string => {
  if (!dateString) return '';
  // Extract just the date part (YYYY-MM-DD) from ISO string
  const parts = dateString.split('T');
  return parts[0] || '';
};

/**
 * Format service date to readable format with year (e.g., "Oct 7, 2025")
 * This format is specifically required for service dates to clearly show the year.
 */
export const formatServiceDate = (dateString: string): string => {
  if (!dateString) return '';

  try {
    const date = new Date(dateString);

    // Check if date is valid
    if (isNaN(date.getTime())) {
      return '';
    }

    // Format as "Oct 7, 2025"
    const options: Intl.DateTimeFormatOptions = {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    };

    return date.toLocaleDateString('en-US', options);
  } catch (error) {
    console.error('Error formatting service date:', error);
    return '';
  }
};

// getInitials removed - use the consolidated version from @/utils/formatters
